import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-upload-estamp-parent',
  templateUrl: './bulk-upload-estamp-parent.component.html',
  styleUrls: ['./bulk-upload-estamp-parent.component.scss'],
  standalone: false,
})
export class BulkUploadEstampParentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
